export default __webpack_public_path__ + "static/media/mental-tip.c40edb3b.svg";